/** Busca universal: pontua cada registro heterogêneo (produto, cliente,
 * documento do Knowledge Hub...) pela sobreposição de termos com a consulta,
 * sem depender de um motor de busca externo. */
export function rankSearchResults(query, entries) {
    const terms = query.toLowerCase().split(/\s+/).filter((term) => term.length > 1);
    if (terms.length === 0)
        return [];
    return entries
        .map((entry) => {
        const haystack = `${entry.title} ${entry.subtitle ?? ""}`.toLowerCase();
        const matched = terms.filter((term) => haystack.includes(term)).length;
        return { ...entry, score: matched / terms.length };
    })
        .filter((entry) => entry.score > 0)
        .sort((a, b) => b.score - a.score);
}
/**
 * LGPD — direito ao esquecimento. Mantém o registro (para não quebrar
 * pedidos/eventos já ligados ao cliente) mas remove todo dado pessoal
 * identificável; `customer_status` passa a refletir a anonimização.
 */
export function anonymizeCustomer(customer) {
    return {
        ...customer,
        full_name: "[removido a pedido do titular]",
        phone: null,
        email: null,
        tags: [],
        customer_status: "anonymized"
    };
}
/** Consolida os dados pessoais de um cliente para exportação (LGPD, portabilidade). */
export function buildCustomerDataExport(customer, related) {
    return {
        customer,
        conversations: related.conversations ?? [],
        leads: related.leads ?? [],
        orders: related.orders ?? [],
        exportedAt: new Date().toISOString()
    };
}
